import { useEffect, useRef } from 'react';
import { useToggle } from '~/hooks';
import { IInputInviteCandidateValue } from '../Types';

interface IUseDateRemovalProps {
  onRemoveProfessional(index: number): void;
}

export const useProfessionalRemoval = ({ onRemoveProfessional }: IUseDateRemovalProps) => {
  const [isShowConfirmation, controls] = useToggle(false);

  const selectedValueRef = useRef<{ index: number; value: IInputInviteCandidateValue } | undefined>(
    undefined,
  );

  const handleRemoveProfessional = (value: IInputInviteCandidateValue, index: number) => {
    selectedValueRef.current = { index, value };
    controls.setOn();
  };

  const handleConfirmRemoval = () => {
    controls.setOff();
    if (selectedValueRef.current) {
      onRemoveProfessional(selectedValueRef.current.index);
      selectedValueRef.current = undefined;
    }
  };

  const handleDeclineRemoval = () => {
    selectedValueRef.current = undefined;
    controls.setOff();
  };

  useEffect(() => {
    return () => {
      selectedValueRef.current = undefined;
    };
  }, []);

  return {
    context: selectedValueRef.current,
    isShowConfirmation,
    ref: selectedValueRef,
    handleConfirmRemoval,
    handleDeclineRemoval,
    handleRemoveProfessional,
  };
};
